export const USER = JSON.parse(localStorage.getItem('user'));
export const TOKEN = USER ? USER.usuario.userAccessToken : null;
export const USERNAME = USER ? USER.usuario.loginUsuario : null;
export const IDUSUARIO = USER ? USER.usuario.idUsuario : null;
export const LIST_IDPROCESO = USER ? USER.procesoList : null;
export const OPTIONS_LIST = USER ? USER.opcionList : null;
export const USUARIO_NOMBRE = USER ? (USER.usuario.apellido +' '+ USER.usuario.nombre) : null; 
export const PATH = USER && USER.path ? USER.path : '/desa/';
// MODO CONSULTA DE ENTREGAS
export const IDPROCESO_MCDE = LIST_IDPROCESO
                                ? (LIST_IDPROCESO.filter(({ idProceso }) =>
                                                          idProceso === 30).length === 1)
                                : null;
// VER PEDIDOS CON PDI CON PENDIENTES
export const IDPROCESO_PCPCP = LIST_IDPROCESO
                                ? (LIST_IDPROCESO.filter(({ idProceso }) =>
                                                          idProceso === 31).length === 1)
                                : null;



// WEBPACK FOOTER //
// ./src/constants/storage.js